const defaultAxisDecimals = 2;
const formatDisplayValue = (value, decimals) => {
    if (Math.abs(value - Math.round(value)) < 1e-9) {
        return value.toFixed(0);
    }
    return value.toFixed(decimals);
};
export const formatDistance = (distanceUnitPort, sceneMeters, decimals = defaultAxisDecimals) => {
    const displayValue = distanceUnitPort.toDisplay(sceneMeters);
    return `${formatDisplayValue(displayValue, decimals)} ${distanceUnitPort.label}`;
};
//# sourceMappingURL=distance-format.js.map